module.exports = __webpack_public_path__ + "static/extras-d20d4d69b79237ed3e8c4111049eb528.svg";